<nav class="
    navbar navbar-light
    p-0
    m-0
    navbar-expand-sm
    border-top border-primary border-2
  " data-test-selector="main-nav">
  <div class="container-fluid p-0 m-0" data-test-selector="left-nav">
    <div class="w-50">
      <ul class="navbar-nav align-items-center ms-1">
        <li class="nav-item">
          <!--          check if list is empty instead of GPO-->
          <div *ngIf="available(itemsLeft).length > 0" ngbDropdown class="d-inline-block">
            <button class="btn btn-link text-dark ms-2 me-2" ngbDropdownToggle data-test-selector="nav-hotspot">
              <i class="far fa-bars fa-lg" aria-hidden="true"></i>
            </button>

            <div ngbDropdownMenu class="drop-nav-menu">
              <ul data-test-selector="left-nav-menu" class="drop-nav left">
                <li *ngFor="let menuItem of available(itemsLeft)">
                  <a href="{{ menuItem.url }}" [innerHtml]="menuItem.text" *ngIf="!menuItem.rule && menuItem.url && menuItem?.hasPermission !== false"></a>
                  <a [routerLink]="menuItem.routerLink" [queryParams]="menuItem.queryParams" [innerHtml]="menuItem.text"
                    *ngIf="!menuItem.rule && menuItem.routerLink && menuItem?.hasPermission !== false"></a>
                  <div class="dropHeader" [innerHtml]="menuItem.header" *ngIf="menuItem.rule"></div>
                  <ul *ngIf="!menuItem.rule">
                    <ng-container *ngFor="let subMenuItem of menuItem.subUrls">
                      <li *ngIf="subMenuItem?.hasPermission !== false">
                        <a href="{{ subMenuItem.url }}" [innerHtml]="subMenuItem.text" *ngIf="subMenuItem.url"></a>
                        <a [routerLink]="subMenuItem.routerLink" [queryParams]="subMenuItem.queryParams"
                          [innerHtml]="subMenuItem.text" *ngIf="subMenuItem.routerLink"></a>
                      </li>
                    </ng-container>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="nav-item hidden-md-down" data-test-selector="nav-label-org-name">
          <span class="navbar-text p-0 m-0 ms-1">{{
            currentUser?.organization?.name
            }}</span>
        </li>
      </ul>
    </div>

    <div class="navbar-nav mx-auto apt" data-test-selector="center-nav">
      <a href="{{ getHomePathByOrgType() }}" class="navbar-brand">
        <img [src]="logoUrl" alt="aptitude Logo" width="130" height="31"
          class="d-inline-block align-top" />
      </a>
    </div>

    <div class="navbar-collapse collapse dual-nav w-50 order-2" data-test-selector="right-nav">
      <ul class="nav navbar-nav ms-auto align-items-center p-0 m-0">
        <div class="environmentInfo" *ngIf="currentUser?.environment">
          {{ currentUser?.emailAddress }}<br />
          {{ currentUser?.environment?.projectVersion }}({{
          currentUser?.environment?.buildNumber
          }}) {{ currentUser?.environment?.environmentName
          }}{{ currentUser?.environment?.inDevMode ? '-Dev Mode' : '' }}
        </div>
        <li class="nav-item hidden-md-down">
          <span class="navbar-text p-0 m-0">
            <!-- <small>{{ currentUser?.environment.environmentName }} - {{ currentUser?.emailAddress }}</small> -->
          </span>
        </li>
        <li class="nav-item">
          <div ngbDropdown class="d-inline-block">
            <button class="btn btn-link text-dark ms-2 me-2" ngbDropdownToggle data-test-selector="nav-hotspot">
              Settings
              <i class="fa fa-cog fa-lg" aria-hidden="true"></i>
            </button>

            <div ngbDropdownMenu>
              <ul data-test-selector="nav-menu" class="drop-nav right">
                <li *ngFor="let menuItem of available(itemsRight)">
                  <a (click)="menuItem.click()" [innerHtml]="menuItem.text" *ngIf="
                      !menuItem.rule && menuItem.click
                    "></a>
                  <a href="{{ menuItem.url }}" [innerHtml]="menuItem.text" *ngIf="
                      !menuItem.rule && menuItem.url
                    "></a>
                  <a [routerLink]="menuItem.routerLink" [queryParams]="menuItem.queryParams" [innerHtml]="menuItem.text" *ngIf="
                      !menuItem.rule &&
                      menuItem.routerLink
                    "></a>
                  <div class="dropHeader" [innerHtml]="menuItem.header" *ngIf="menuItem.rule"></div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>

<router-outlet></router-outlet>
